import { FCC } from "../../../../../../utils/reactHelpers/types"

export const BottomActionsSection: FCC = props => (
  <div className={"flex flex-col gap-4"}>{props.children}</div>
)
